module.exports = __webpack_public_path__ + "img/emoji_36.8011b658.png";